export function isPlanTableMaxHeightExceeded(selectedPlans, plans, maxHeight, newPlanId, includeRestrictionNotes) {
	const cellStyle =
		'font-size: 13px; font-weight: 400; padding: 2px;line-height: 19.5px;text-wrap-mode: wrap; word-break: break-word;font-family: Arial; max-width: 270px';
	const tempTable = document.createElement('div');
	let planCount = 0;
	tempTable.style.visibility = 'hidden';
	tempTable.style.position = 'absolute';
	tempTable.style.left = '-9999px';

	document.body.appendChild(tempTable);
	for (const selectedPlan of selectedPlans) {
		const plan = plans.find((p) => p.data.planId === selectedPlan.planId);
		const row = createRow(plan, cellStyle, includeRestrictionNotes);
		tempTable.appendChild(row);
		planCount++;
	}
	if (newPlanId) {
		const newPlan = plans.find((p) => p.data.planId === newPlanId);
		const newRow = createRow(newPlan, cellStyle, includeRestrictionNotes);
		tempTable.appendChild(newRow);
		planCount++;
	}

	const height = tempTable.offsetHeight;
	document.body.removeChild(tempTable);
	console.log('Calculated table height:', height, ' for ', planCount, 'plans');
	return height > maxHeight;
}

function createRow(plan, cellStyle, includeRestrictionNotes) {
	const row = document.createElement('div');
	const cell = document.createElement('div');
	cell.style = cellStyle;
	cell.innerHTML = plan.data.name || '';
	row.appendChild(cell);
	if (includeRestrictionNotes) {
		const notesCell = document.createElement('div');
		notesCell.style = cellStyle;
		notesCell.innerHTML = plan.data.formularyRestriction || '';
		row.appendChild(notesCell);
	}
	return row;
}
